import { ApiClient } from '../util/api-client';
import { AuthenticatedUser } from '../models/response';
import { FeedbackFormValues } from '../components/client-feedback/validate-feedback';

export class ClientFeedbackService {
    public static async feedback(feedback: FeedbackFormValues) {
        return ApiClient.post<FeedbackFormValues, AuthenticatedUser>('feedbacks', feedback);
    }
}
